import { IconButton } from '@material-ui/core';
import { ArrowForwardIos, Clear, Close } from '@material-ui/icons';
import MuiButton from 'components/common/button/MuiButton';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { useCreateProjectLibary } from 'lib/hooks/project/useCreateProjectLibary';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import cx from 'classnames';
import { icon_check, icon_check_small } from 'components/base/images';

const CreateProjectLibrary = () => {
  const {
    tabIndex,
    isValidLibrary,
    companyKeyword,
    implantKeyword,
    typeKeyword,
    subTypeKeyword,
    companyList,
    implantList,
    typeList,
    subTypeList,
    onSaveLibrary,
    onLibraryClose,
    onTabClick,
    onLibraryClick,
    onDeleteItemClick,
  } = useCreateProjectLibary();
  const { t } = useTranslation();

  const tabList = [
    {
      index: 0,
      title: t('LIBRARY_COMPANY'),
    },
    {
      index: 1,
      title: t('LIBRARY_IMPLANT'),
    },
    {
      index: 2,
      title: t('LIBRARY_TYPE'),
    },
    {
      index: 3,
      title: t('LIBRARY_SUB_TYPE'),
    },
  ];

  return (
    <StyledCreateProjectLibrary>
      {/* title box */}
      <div className="createProjectLibrary__title_box">
        <CustomText fontSize={26} fontWeight={600} fontColor="#222">
          <T>PROJECT_SELECT_LIBRARY</T>
        </CustomText>
        <IconButton onClick={onLibraryClose}>
          <Clear />
        </IconButton>
      </div>
      {/* content box */}
      <div className="createProjectLibrary__content_box">
        <div className="createProjectLibrary__library_wrapper">
          <div className="createProjectLibrary__tab_box">
            {tabList.map((tabItem, index) => {
              const isSelected = tabIndex === tabItem.index;
              // let isDisabled = tabIndex < tabItem.index;
              let isDisabled = false;

              if (tabItem.index === 1) {
                isDisabled = tabIndex < tabItem.index && !implantKeyword.value;
              }
              if (tabItem.index === 2) {
                isDisabled = tabIndex < tabItem.index && !typeKeyword.value;
              }
              if (tabItem.index === 3) {
                isDisabled = tabIndex < tabItem.index && !subTypeKeyword.value;
              }

              return (
                <button
                  key={index}
                  className={cx(`createProjectLibrary__tab_item`, {
                    selected: isSelected,
                    disabled: isDisabled,
                  })}
                  disabled={isDisabled}
                  onClick={() => onTabClick(tabItem.index)}
                >
                  <CustomText fontSize={14}>{tabItem.title}</CustomText>
                </button>
              );
            })}
          </div>
          {tabIndex === 0 && (
            <LibraryItem
              tabIndex={tabIndex}
              libraryList={companyList}
              libraryIndex={companyKeyword.value}
              onLibraryClick={onLibraryClick}
            />
          )}
          {tabIndex === 1 && (
            <LibraryItem
              tabIndex={tabIndex}
              libraryList={implantList}
              libraryIndex={implantKeyword.value}
              onLibraryClick={onLibraryClick}
            />
          )}
          {tabIndex === 2 && (
            <LibraryItem
              tabIndex={tabIndex}
              libraryList={typeList}
              libraryIndex={typeKeyword.value}
              onLibraryClick={onLibraryClick}
            />
          )}
          {tabIndex === 3 && (
            <LibraryItem
              tabIndex={tabIndex}
              libraryList={subTypeList}
              libraryIndex={subTypeKeyword.value}
              onLibraryClick={onLibraryClick}
            />
          )}
        </div>
        {(!!companyKeyword.value ||
          !!implantKeyword.value ||
          !!typeKeyword.value ||
          !!subTypeKeyword.value) && (
          <div className="createProjectLibrary__selected_item_box">
            {!!companyKeyword.value && (
              <CustomText fontSize={16} fontColor="#666">
                {companyList?.find(companyItem => companyItem.index === companyKeyword.value)?.name}
              </CustomText>
            )}
            {!!implantKeyword.value && (
              <ArrowForwardIos style={{ fontSize: 14, color: '9EA4BE' }} />
            )}
            {!!implantKeyword.value && (
              <CustomText fontSize={16} fontColor="#666">
                {implantList?.find(implantItem => implantItem.index === implantKeyword.value)?.name}
              </CustomText>
            )}
            {!!typeKeyword.value && <ArrowForwardIos style={{ fontSize: 14, color: '9EA4BE' }} />}
            {!!typeKeyword.value && (
              <CustomText fontSize={16} fontColor="#666">
                {typeList?.find(typeItem => typeItem.index === typeKeyword.value)?.name}
              </CustomText>
            )}
            {!!subTypeKeyword.value && (
              <ArrowForwardIos style={{ fontSize: 14, color: '9EA4BE' }} />
            )}
            {!!subTypeKeyword.value && (
              <CustomText fontSize={16} fontColor="#666">
                {subTypeList?.find(subTypeItem => subTypeItem.index === subTypeKeyword.value)?.name}
              </CustomText>
            )}
            <div
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              onClick={onDeleteItemClick}
            >
              <Close style={{ fontSize: 20, color: '9EA4BE' }} />
            </div>
          </div>
        )}
      </div>
      {/* button box */}
      <div className="createProjectLibrary__button_box">
        <MuiButton
          disableElevation
          disabled={!isValidLibrary}
          variant="contained"
          className="createProjectLibrary__button_item"
          onClick={() => onSaveLibrary(true)}
        >
          <T>APPLY_ALL</T>
        </MuiButton>
        <MuiButton
          disableElevation
          disabled={!isValidLibrary}
          variant="contained"
          className="createProjectLibrary__button_item"
          onClick={() => onSaveLibrary(false)}
        >
          <T>GLOBAL_SAVE</T>
        </MuiButton>
      </div>
    </StyledCreateProjectLibrary>
  );
};

interface LibraryItemProps {
  tabIndex: number;
  libraryList: any;
  libraryIndex: string;
  onLibraryClick: (tabIndex: number, index: string, libraryIdx?: number) => void;
}

const LibraryItem = ({ tabIndex, libraryList, libraryIndex, onLibraryClick }: LibraryItemProps) => {
  return (
    <StyledLibraryItem className="createProjectLibrary__library_box">
      {libraryList?.map((libraryItem: any, index: number) => {
        const isSelected = libraryIndex === libraryItem.index;

        return (
          <button
            key={index}
            className={cx(`createProjectLibrary__library_item`, {
              selected: isSelected,
            })}
            onClick={() =>
              onLibraryClick(tabIndex, libraryItem.index, libraryItem.implantLibraryIdx)
            }
          >
            <CustomText fontSize={16}>{libraryItem.name}</CustomText>
            {isSelected && (
              <StyledOutlineCheck>
                <img style={{ width: '100%', height: '100%' }} src={icon_check_small} />
              </StyledOutlineCheck>
            )}
          </button>
        );
      })}
    </StyledLibraryItem>
  );
};

const StyledCreateProjectLibrary = styled.div`
  width: 100%;
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  .createProjectLibrary__title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .createProjectLibrary__content_box {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin-bottom: 40px;
    .createProjectLibrary__library_wrapper {
      width: 100%;
      border-radius: 10px;
      border: 1px solid #00a6e2;
      overflow: hidden;
      .createProjectLibrary__tab_box {
        display: flex;
        .createProjectLibrary__tab_item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          padding: 8px 12px;
          color: #444;
          &.selected {
            background-color: #00a6e2;
            color: #fff !important;
          }
          &.disabled {
            color: #ccccd4;
          }
          &:nth-child(1) {
            border-bottom: 1px solid #ccccd4;
            border-right: 1px solid #ccccd4;
          }
          &:nth-child(2) {
            border-bottom: 1px solid #ccccd4;
            border-right: 1px solid #ccccd4;
          }
          &:nth-child(3) {
            border-bottom: 1px solid #ccccd4;
            border-right: 1px solid #ccccd4;
          }
          &:nth-child(4) {
            border-bottom: 1px solid #ccccd4;
          }
        }
      }
    }
    .createProjectLibrary__selected_item_box {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      column-gap: 8px;
      padding: 8px 10px;
      background-color: #f9f9fb;
      border-radius: 4px;
      line-height: 20px;
    }
  }
  .createProjectLibrary__button_box {
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .createProjectLibrary__button_item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 190px;
      height: 45px;
      padding: 0 15px;
      border-radius: 3px;
      color: white;
    }
  }
`;

const StyledLibraryItem = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 306px;
  .createProjectLibrary__library_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    &.selected {
      background-color: #f9f9fb;
      font-weight: 600;
    }
    &:hover {
      background-color: #f9f9fb;
    }
  }
`;

const StyledOutlineCheck = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #00a6e2;
  padding: 2px;
`;

export default CreateProjectLibrary;
